import styled from 'styled-components';
import { BaseContainer } from '../../styles/sharedStyles';

export const SiteFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 40px 0;
  left: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    padding: 10px 0;
  }
`;

export const Footerlink = styled.a`
  margin-left: 5px;
  text-decoration: underline;
`;

export const Disclaimer = styled.div`
  font-size: 0.85rem;
  text-align: center;
`;

export const Container = styled(BaseContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  & * {
    color: #3d3935;
  }
`;
export const TeConsentBlackBar = styled.div``;
